var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEuro(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 14A6 6 0 108 2a6 6 0 000 12zm1.292-3.408a3.31 3.31 0 01-.513.039c-.24 0-.46-.034-.659-.103a1.285 1.285 0 01-.503-.317 1.505 1.505 0 01-.327-.562 2.607 2.607 0 01-.111-.737h1.747v-.669H7.178v-.64h1.748v-.668H7.183c.013-.24.047-.451.102-.635.075-.238.182-.432.322-.581.14-.153.31-.267.508-.342a1.94 1.94 0 01.679-.112 3.082 3.082 0 01.972.161l.141-.982a5.968 5.968 0 00-.576-.107 3.818 3.818 0 00-.586-.044c-.413 0-.79.06-1.133.18-.338.121-.633.302-.883.543-.248.24-.44.54-.577.898a3.337 3.337 0 00-.195 1.02h-.85v.67h.845v.64h-.845v.668h.846c.009.422.075.795.2 1.118.136.345.326.635.57.87.245.23.533.405.865.522.335.117.703.176 1.103.176a5.443 5.443 0 001.216-.146l-.141-.977c-.15.052-.308.09-.474.117z",
    fill: "#3C88EA"
  })));
}
SvgEuro.displayName = 'Euro';
export default SvgEuro;